import { Body } from '@cognite/cogs.js';
import { ProgressBar } from 'components';
import { Icon } from 'components/Icon';
import { useEffect, useState } from 'react';
import { useGetAllRuleRunStatusQuery } from 'types/dt-graphql-apollo-v2';

const LIMIT = 10000;

type Props = {
  schemaIds: string[];
};

/**
 * Fetches the rule runs for the given schemas and shows their total count against a limit of 10000
 */
export const RuleRunsCount = ({ schemaIds }: Props) => {
  const [totalRuleRuns, setTotalRuleRuns] = useState(0);

  const {
    data: allRuleRuns,
    loading: loadingAllRuleRuns,
    refetch: refetchAllRuleRuns,
  } = useGetAllRuleRunStatusQuery({
    variables: {
      schemaIds,
      cursor: null,
    },
  });

  useEffect(() => {
    const getMoreRuns = async () => {
      const totalSoFar = allRuleRuns?.listRuleRunStatus?.items?.length || 0;
      setTotalRuleRuns((state) => state + totalSoFar);

      await refetchAllRuleRuns({
        schemaIds,
        cursor: allRuleRuns?.listRuleRunStatus?.pageInfo.startCursor,
      });
    };

    if (allRuleRuns?.listRuleRunStatus?.pageInfo.hasNextPage) {
      getMoreRuns();
    }
  }, [allRuleRuns]);

  const percentageRuleRunsUsed = totalRuleRuns / 100;

  return (
    <>
      {loadingAllRuleRuns ? (
        <Icon type="Loader" />
      ) : (
        <div>
          <Body level={3} strong>{`${totalRuleRuns} / ${LIMIT} runs`}</Body>
          <ProgressBar
            value={percentageRuleRunsUsed}
            trackColor="var(--cogs-primary)"
          />
        </div>
      )}
    </>
  );
};
